document.addEventListener("DOMContentLoaded", async function () {
  const profile = await loadProfile();
  let selectedGender = profile?.gender || null;
  
  const childNameInput = document.getElementById("childName");
  const nameError = document.getElementById("name-error");
  const buttons = document.querySelectorAll(".select-option");
  const continueBtn = document.getElementById("continue-btn");

  function validateName(name) {
    if (name.includes(" ")) {
      return "Please enter only a first name without spaces.";
    }
    if (name.length > 10) {
      return "Your first name must not exceed 10 characters.";
    }
    if (!/^[A-Z][a-z]+$/.test(name)) {
      if (!/^[A-Za-z]+$/.test(name)) {
        return "Name must contain only alphabets.";
      }
      return "First letter should be uppercase, the rest lowercase (e.g., Moiz).";
    }
    return null;
  }

  function checkForm() {
    const name = childNameInput.value.trim();
    const errorMsg = validateName(name);

    if (errorMsg) {
      nameError.textContent = errorMsg;
      nameError.style.display = "block";
      continueBtn.disabled = true;
    } else {
      nameError.style.display = "none";
      if (selectedGender) {
        continueBtn.disabled = false;
      }
    }
  }

  buttons.forEach((button, index) => {
      if(
        (index === 0 && selectedGender === "BOY") ||
        (index === 1 && selectedGender === "GIRL" )
      ){
        button.classList.add("active");
      }
    
    button.addEventListener("click", function () {
      selectedGender = this.getAttribute("data-gender");
      buttons.forEach((btn) => btn.classList.remove("active"));
      this.classList.add("active");
      checkForm();
    });
  });

  childNameInput.addEventListener("change", function () {
    checkForm();
  });
  childNameInput.value = profile?.name || '';
  checkForm();

  continueBtn.addEventListener("click", async function () {
    const name = childNameInput.value.trim();
    const errorMsg = validateName(name);

    if (!errorMsg && selectedGender) {
      await saveProfile({
        name : name,
        gender: selectedGender,
        dedicationText : `Dear ${name},\n\nYou have brought such joy and wonder to our lives. We hope that you find the same joy and happiness, wherever your life takes you.`,
        imageBase64 : ""
      });
      window.location.href = "/pages/preview";
    }
  });
});
  
